import React from "react";

export default function ApiTest({ api }: { api: any }) {
  if (api.Status !== "draft") {
    return (
      <div className="alert alert-warning my-4">
        You can only test APIs in draft mode. Please change the status to draft
        to enable testing.
      </div>
    );
  }
  return (
    <div>
      <h5>Inspect your application requests</h5>
      Example response when connecting to this API in draft status:
      <div className="bg-white rounded p-3 mb-3">
        <pre>
          {JSON.stringify(
            {
              message: "API connection authenticated in draft state",
              request_id: "1759153935-QkLMFVWeeBvczVLRpo9SD4",
            },
            null,
            2
          )}
        </pre>
      </div>
      Last received request paylod:
      <div className="bg-white rounded p-3">
        {api.RequestDataLog ? (
          <pre>{JSON.stringify(api.RequestDataLog, null, 2)}</pre>
        ) : (
          <div className="alert alert-secondary">No previous attempts</div>
        )}
      </div>
    </div>
  );
}
